/* eslint-disable react-hooks/exhaustive-deps */
import { HStack, Box, Center, position, Text, VStack, Tooltip } from "@chakra-ui/react"
import { useEffect } from "react"
import { useState } from "react"
import CQLineChart from "../../../components/CQLineChart"
import AppColors from "../../../constants/AppColors"
import { FONT_FAMILY } from "../../../constants/Theme"
import {
    CQSelect,
} from '@laxmimanogna/code-quick-components';

const RVUOpportunity = ({ practiceChartData, auditChartData, stateChartData, extraRVUData, radioClick, checked, tile, dropdown, weightedAvgData }) => {
    const [isHovering, setIsHovering] = useState(false);

    const commonSelectStyles = {
        control: props => ({
            ...props,
            borderRadius: 7,
            paddingRight: 10,
            paddingLeft: 10,
            fontSize: '12px',
            color: AppColors.secondary,
            borderColor: AppColors.secondary,
            '&:hover': {
                borderColor: AppColors.primary,
            },
        }),
        placeholder: props => ({
            ...props,
            color: AppColors.secondary,
            fontWeight: 'bold'
        }),
        dropdownIndicator: props => ({
            ...props,
            color: AppColors.secondary
        }),
        singleValue: props => ({
            ...props,
            fontWeight: 'bold',
            color: AppColors.secondary,
        }),
        option: props => ({
            ...props,
            fontSize: '12px',
            zIndex: 100
        }),
        menu: props => ({
            ...props,
            zIndex: 100
        }),
    }
    const [selectedOption, setSelectedOption] = useState('')

    useEffect(() => {
        if (checked) {
            const temp = dropdown.find(op => op.value === checked)
            setSelectedOption(temp)
        }
    }, [checked, dropdown])

    return <Box position="relative">
        {/* Compact horizontal bar with dots and percentages */}
        {weightedAvgData && (
            <Box 
                position="absolute" 
                top="-5%"
                right="1%"
                zIndex={5}
                onMouseEnter={() => setIsHovering(true)}
                onMouseLeave={() => setIsHovering(false)}
            >
                {!isHovering ? (
                    // Collapsed State - Compact with dots and percentages
                    <HStack
                        cursor="pointer"
                        spacing="0.4em"
                        padding="clamp(3px, 0.5vh, 5px) clamp(6px, 0.8vw, 8px)"
                    >
                        {weightedAvgData.practice !== undefined && (
                            <HStack spacing="0.2em">
                                <Box 
                                    w="clamp(4px, 0.6vw, 6px)"
                                    h="clamp(4px, 0.6vw, 6px)"
                                    borderRadius="full" 
                                    bg={AppColors.primary}
                                    flexShrink={0}
                                />
                                <Text 
                                    fontSize="10px"
                                >
                                    {weightedAvgData.practice}
                                </Text>
                            </HStack>
                        )}
                        {weightedAvgData.revintegrity !== undefined && (
                            <HStack spacing="0.2em">
                                <Box 
                                    w="clamp(4px, 0.6vw, 6px)"
                                    h="clamp(4px, 0.6vw, 6px)"
                                    borderRadius="full" 
                                    bg={AppColors.secondary}
                                    flexShrink={0}
                                />
                                <Text 
                                    fontSize="10px"
                                >
                                    {weightedAvgData.revintegrity}
                                </Text>
                            </HStack>
                        )}
                        {weightedAvgData.state !== undefined && (
                            <HStack spacing="0.2em">
                                <Box 
                                    w="clamp(4px, 0.6vw, 6px)"
                                    h="clamp(4px, 0.6vw, 6px)"
                                    borderRadius="full" 
                                    bg={AppColors.gray}
                                    flexShrink={0}
                                />
                                <Text 
                                    fontSize="10px"
                                    // fontWeight="600"
                                    // color={AppColors.gray}
                                >
                                    {weightedAvgData.state}
                                </Text>
                            </HStack>
                        )}
                    </HStack>
                ) : (
                    // Expanded State - Details box
                    <VStack 
                        bg="rgba(255, 255, 255, 0.9)"
                        padding="clamp(8px, 1.5vh, 14px) clamp(10px, 1.5vw, 14px)"
                        spacing="clamp(4px, 0.8vh, 6px)"
                        align="stretch"
                        minW="clamp(110px, 15vw, 140px)"
                        borderRadius="clamp(4px, 0.6vw, 6px)"
                        boxShadow="0 2px 8px rgba(0,0,0,0.1)"
                    >
                        <Text 
                            fontSize="clamp(10px, 1.3vw, 12px)"
                            fontWeight="bold" 
                            color={AppColors.secondary}
                            textAlign="center"
                            mb="clamp(2px, 0.4vh, 4px)"
                        >
                            Weighted Avg
                        </Text>
                        {weightedAvgData.practice !== undefined && (
                            <HStack spacing="clamp(4px, 0.6vw, 6px)">
                                <Box 
                                    w="clamp(6px, 0.8vw, 7px)"
                                    h="clamp(6px, 0.8vw, 7px)"
                                    borderRadius="full" 
                                    bg={AppColors.primary}
                                    flexShrink={0}
                                />
                                <Text 
                                    fontSize="clamp(9px, 1.2vw, 11px)"
                                    color="gray.700"
                                >
                                    Practice: <strong>{weightedAvgData.practice}</strong>
                                </Text>
                            </HStack>
                        )}
                        {weightedAvgData.revintegrity !== undefined && (
                            <HStack spacing="clamp(4px, 0.6vw, 6px)">
                                <Box 
                                    w="clamp(6px, 0.8vw, 7px)"
                                    h="clamp(6px, 0.8vw, 7px)"
                                    borderRadius="full" 
                                    bg={AppColors.secondary}
                                    flexShrink={0}
                                />
                                <Text 
                                    fontSize="clamp(9px, 1.2vw, 11px)"
                                    color="gray.700"
                                >
                                    Audit: <strong>{weightedAvgData.revintegrity}</strong>
                                </Text>
                            </HStack>
                        )}
                        {weightedAvgData.state !== undefined && (
                            <HStack spacing="clamp(4px, 0.6vw, 6px)">
                                <Box 
                                    w="clamp(6px, 0.8vw, 7px)"
                                    h="clamp(6px, 0.8vw, 7px)"
                                    borderRadius="full" 
                                    bg={AppColors.gray}
                                    flexShrink={0}
                                />
                                <Text 
                                    fontSize="clamp(9px, 1.2vw, 11px)"
                                    color="gray.700"
                                >
                                    State: <strong>{weightedAvgData.state}</strong>
                                </Text>
                            </HStack>
                        )}
                    </VStack>
                )}
            </Box>
        )}
        <CQLineChart
            chartData={[
                {
                    label: practiceChartData.text ? practiceChartData.text : 'Practice',
                    data: practiceChartData?.data,
                    borderColor: AppColors.primary,
                    backgroundColor: AppColors.primary,
                    tension: 0.4,
                },
                {
                    label: auditChartData.text ? auditChartData.text : 'Audit',
                    data: auditChartData?.data,
                    borderColor: AppColors.secondary,
                    backgroundColor: AppColors.secondary,
                    tension: 0.4,
                },
                {
                    label: stateChartData.text ? stateChartData.text : 'State',
                    data: stateChartData?.data,
                    borderColor: AppColors.gray,
                    backgroundColor: AppColors.gray,
                    tension: 0.4,
                },
            ]}
            xAxis={stateChartData.label}
            optionProps={{
                plugins: {
                    legend: {
                        ...(tile ? {} : { onClick: () => { } }),
                        display: true,
                        position: 'bottom',
                        align: 'end',
                        labels: {
                            boxWidth: 20,
                            boxHeight: 0.5,
                            color: 'black',
                            font: {
                                size: 10,
                                family: FONT_FAMILY.ptSans,
                            },
                        },
                    },
                    tooltip: {
                        callbacks: {
                            label: function(context) {
                            const value = context.raw;
                            return `${context.dataset.label}: ${value.toFixed(1)}%`; // tooltip as percentage
                            }
                        }
                    },
                },
                scales: {
                    y: {
                        max: 100,
                        beginAtZero: true,
                        ticks: {
                            // Include a dollar sign in the ticks
                            callback: function (value, index, ticks) {
                                return value + '%';
                            },
                            color: 'black',
                            font: {
                                family: FONT_FAMILY.ptSans,
                                size: 10,
                            }
                        },
                    },
                    x: {
                        beginAtZero: true,
                        ticks: {
                            color: 'black',
                            font: {
                                family: FONT_FAMILY.ptSans,
                                size: 10,
                            }
                        },
                    }
                },
            }}
        />
        <VStack spacing={4} align="center">
            {/* Extra info below chart / above dropdown */}
            <Box w="full" display="flex" justifyContent="flex-end" paddingRight={2}>
            {(((extraRVUData?.states || []).filter(s => s !== null).length > 0) &&
                ((extraRVUData?.specialty || []).filter(s => s !== null).length > 0)) && (
                <Tooltip
                    bg="whiteAlpha.900"
                    color="black"
                    borderRadius="md"
                    border="1px solid #43dde0"
                    label={
                        <div>
                            <div><b>States:</b> {(extraRVUData?.states || []).filter(s => s !== null).join(', ')}</div>
                            <div><b>Specialties:</b> {(extraRVUData?.specialty || []).filter(s => s !== null).join(', ')}</div>
                            <div><b>Year:</b> {extraRVUData?.year}</div>
                        </div>
                    }
                    placement="left"
                >
                    <Text fontSize="10px" cursor="pointer">
                        {`${(extraRVUData?.states || []).filter(s => s !== null)[0] || ''}${(extraRVUData?.states || []).filter(s => s !== null).length > 1 ? '..' : ''}, ` +
                        `${(extraRVUData?.specialty || []).filter(s => s !== null)[0] || ''}${(extraRVUData?.specialty || []).filter(s => s !== null).length > 1 ? '..' : ''}, ` +
                        `${extraRVUData?.year || ''}`}
                    </Text>
                </Tooltip>
            )}
            </Box>

            <Box onClick={(e) => {
                e.stopPropagation()
            }}>
                {dropdown.length ? <CQSelect
                    options={dropdown}
                    placeholder='Select Option'
                    variant='primary'
                    isSearchable={false}
                    styles={commonSelectStyles}
                    value={dropdown.find(option => option.value === checked)}
                    onChange={(data) => {
                        radioClick(data.value)
                    }}
                /> : <Center>
                    No data present for this account
                </Center>}
            </Box>
        </VStack>
    </Box>
}
export default RVUOpportunity